/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrainingMaterialsMainPageComponent} from './training-materials-main-page.component';
import {TrainingMaterialsListModule} from '../../shared/training-materials-list/training-materials-list.module';

@NgModule({
    declarations: [
        TrainingMaterialsMainPageComponent
    ],
    imports: [
        CommonModule,
        TrainingMaterialsListModule
    ]
})
export class TrainingMaterialsMainPageModule {
}

